var map = {
	"./ChasingGhosts/Metadata.ts": 6797,
	"./DoYouCare/Metadata.ts": 2205,
	"./HappySad/Metadata.ts": 2435,
	"./MachineSpokesmen/Metadata.ts": 6382,
	"./Observed/Metadata.ts": 1372,
	"./PayAttention/Metadata.ts": 3663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 974;